<template>
  <b-card>
    <div slot="header">
      <i class="fa fa-user-o"></i> Histórico de Sleekers
    </div>
    <b-row>
      <b-col class="text-center" lg="3" md="4" sm="6" v-for="template in templates" :key="template._id" style="margin-bottom: 50px;">
        <b-row>
          <b-col xs="6">
            <img :src="template.thumbnail"/>
          </b-col>
           <b-col xs="6">
             <b>{{template.insertionDate | moment("DD/MM/YYYY HH:mm")}}</b>
             <br/>
             <b-button @click="goToDesignSave(template._id)" style="margin-top: 30px;">Visualizar</b-button>
          </b-col>
        </b-row>
        
      </b-col>
    </b-row>
  </b-card>
</template>
 
<script>
import config from "../config";
import service from "../service";

export default {
  name: "AccountData",
  data() {
    return {
      me: undefined,
      templates: []
    };
  },
  methods: {
    getMe: function() {
      service.getMe().then(user => {
        this.me = user;
      })
    },
    getDesignHistory: function() {
      service.getDesignHistory().then((result) => {
        this.templates = result.templates;
      });
    },
    goToDesignSave: function(id) {
      this.$router.push({name: "SaveDesign", params: {id: id, dontUseCredits: true}});
    }
  },
  created() {
    this.getMe();
    this.getDesignHistory();
  }
};
</script> 

